export enum AcordoStatus {
  EmAberto = "em-aberto",
  Pago = "pago",
  Cancelado = "cancelado",
  Renegociado = "renegociado",
  Encerrado = "encerrado",
}
